<template>
  <div id="questionBankIndex">
    <h3>内容管理</h3>
    <div class="questions">
      <div ref="question" v-for="(item, index) in questionList" :key="index" class="question">
        <div class="question-title" style="margin: 10px 0; font-weight: 600">
          <span>{{ item.name }}（{{ item.score }}分）</span>
          <!-- pc端样式 -->
          <div class="editGrop">
            <i class="el-icon-edit" @click.stop="handledialog(1, item)"></i>
            <i class="el-icon-circle-plus-outline" @click.stop="handledialog(2, item, true)"></i>
            <!-- <img src="../../assets/img/riLine.png" alt="" /> -->
            <i class="el-icon-delete" @click.stop="handleAddQuestion(3, item)"></i>
          </div>
          <!-- 移动端样式 -->
          <el-popover popper-class="popoClass" :append-to-body="true" class="dropdownGrop" trigger="click" placement="bottom-end">
            <div class="popoBox" @click="handledialog(1, item)"><i class="el-icon-edit"></i>编辑</div>
            <div class="popoBox"><i class="el-icon-circle-plus-outline"></i>新建子集</div>
            <!-- <div class="popoBox"><img src="../../assets/img/riLine.png" alt="" />新建规则</div> -->
            <div class="popoBox" @click="handleAddQuestion(3, item)"><i class="el-icon-delete"></i>删除</div>
            <i slot="reference" class="el-icon-more"></i>
          </el-popover>
        </div>
        <!-- 评价规则 -->
        <div class="rule" v-if="item.evaluationRuleList && item.evaluationRuleList.length">
          <div class="rule-title">评价规则：</div>
          <div class="rule-content">
            <div v-for="(rule, todex) in item.evaluationRuleList" :key="todex" class="rule-item">
              <span>
                {{ todex + 1 }}、 总分值<span class="blue"> {{ rule.score }}</span> 分：{{ rule.name }}
              </span>
            </div>
          </div>
        </div>
        <questItem @success="getQuestionList" v-if="item.questionBankList && item.questionBankList.length" :data="item.questionBankList"></questItem>
      </div>
    </div>
    <div class="quesBtnGuop">
      <el-button @click="handledialog(1)" size="small" type="primary">新增模块</el-button>
    </div>
    <el-dialog @close="dialogClose" :title="`新建${formTiles[form.tier - 1]}`" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="ruleForm" size="small" :model="form" label-position="top">
        <h3 v-if="form.parentName">在「{{ form.parentName }}」下新建</h3>
        <el-form-item :label="`${formTiles[form.tier - 1]}名称`">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.name"> </el-input>
        </el-form-item>
        <el-form-item :label="`${formTiles[form.tier - 1]}分值`">
          <el-input-number size="small" :controls="false" v-model="form.score"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddQuestion(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import questItem from './quesItem/quest_Item.vue';
export default {
  name: 'questionBankIndex',
  components: { questItem },
  data() {
    return {
      questionList: [],
      defaultExpansion: [], // 默认折叠展开的id
      // 新增模块/指标/题目
      dialogFormVisible: false,
      form: {
        name: '', // 名称
        score: 0, // 分数
        tier: 1, // 层级
        parentId: '', // 父级id
        parentName: '', // 父级名称
        id: '', // 当前 id
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      formTiles: ['模块', '指标', '题目'],
    };
  },
  watch: {
    questionList: {
      // 这里计算默认折叠展开的id
      handler(newVal, oldVal) {
        this.defaultExpansion = this.handDfaultFold(newVal);
      },
      deep: true,
    },
  },
  created() {
    this.getQuestionList();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    // 获取题库列表
    getQuestionList() {
      this.$axios.post('api/question/questionList').then((res) => {
        if (res.data.code == 200) {
          this.recursionFun(res.data.data);
          this.questionList = res.data.data || [];
        }
      });
    },
    // 触发 弹出框
    handledialog(tier, item, type) {
      // tier 的意思代表层级
      this.form.tier = tier;
      this.dialogFormVisible = true;
      if (type) {
        // 如果有 type = true，就是新建下一级别
        this.form.parentId = item.id;
        this.form.parentName = item.name;
        return;
      }
      if (item) {
        // 如果有 item 说明是对当前层级进行编辑
        this.form.name = item.name;
        this.form.id = item.id;
        this.form.score = item.score;
        return;
      }
    },
    // 新增 / 编辑 / 删除模块
    handleAddQuestion(type, item) {
      console.log('🚀 ~ this.form:', this.form);
      switch (type) {
        case 1:
          // 新增 / 编辑请求
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              this.httpAddQuestion({ parentId: this.form.parentId, id: this.form.id, name: this.form.name, score: this.form.score, tier: this.form.tier });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
          break;
        case 3:
          // 删除请求
          this.httpDeleteIndustry({ id: item.id });
          break;

        default:
          break;
      }
    },
    httpAddQuestion(parame) {
      this.$axios.post('api/question/addQuestion', parame).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: `${parame.id ? '编辑' : '新增'}成功`,
            type: 'success',
            offset: 80,
          });
          this.getQuestionList();
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    httpDeleteIndustry(parame) {
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/question/deleteIndustry', parame).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              this.getQuestionList();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    dialogClose() {
      this.form = {
        name: '', // 名称
        score: 0, // 分数
        tier: 1, // 层级
        parentId: '', // 父级id
        parentName: '', // 父级名称
        id: '', // 当前 id
      };
    },
    handDfaultFold(data) {
      const indexArr = [];
      diguiFold(data);
      function diguiFold(arr) {
        if (arr && arr.length) {
          arr.forEach((e) => {
            if (e.isFold == false) {
              indexArr.push(e.id);
            }
            diguiFold(e.questionBankList);
          });
        }
      }
      return indexArr;
    },
    recursionFun(arr) {
      if (arr && arr.length) {
        arr.forEach((e) => {
          if (this.defaultExpansion.includes(e.id)) {
            this.$set(e, 'isFold', false);
          } else {
            this.$set(e, 'isFold', true);
          }
          this.$set(e, 'isEditRule', false);
          this.recursionFun(e.questionBankList);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.questions {
  margin: 10px 0;
  height: 100px;
  user-select: none;
  box-sizing: border-box;
  height: calc(100% - 84px);
  overflow: auto;
  // background-color: aquamarine;
  .question {
    cursor: pointer;
    .question-title {
      position: relative;
      display: flex;
      align-items: center;
      &:hover {
        background-color: #e6f7ff;
        .editGrop {
          display: flex;
        }
      }
      .editGrop {
        margin-left: auto;
        display: none;
        width: 80px;
        justify-content: space-between;
        align-items: center;
        i {
          cursor: pointer;
          color: rgba(80, 88, 105, 0.5);
        }
      }
      .dropdownGrop {
        display: none;
        margin-left: auto;
        cursor: pointer;
        font-weight: 600;
        font-size: 20px;
        margin-right: 8px;
      }
    }
    .rule {
      border-radius: 6px;
      margin: 8px 0;
      background-color: rgba(80, 88, 105, 0.06);
      border: 1px solid rgba(80, 88, 105, 0.2);
      padding: 8px 10px;
      color: rgba(80, 88, 105, 1);
      font-size: 14px;
      display: flex;
      .rule-title {
        min-width: 100px;
        color: rgba(80, 88, 105, 0.6);
      }
      .rule-content {
        .blue {
          font-weight: 600;
        }
      }
    }
  }
}
.quesBtnGuop {
  width: calc(100% - 40px);
  height: 60px;
  position: absolute;
  box-sizing: border-box;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 69, 0.05);
}
/deep/ .el-dialog {
  width: 40%;
  border-radius: 10px;
  .el-dialog__header {
    font-weight: 600;
  }
  .el-dialog__body {
    padding: 4px 20px;
    .el-form-item__label {
      padding-bottom: 0;
    }
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .quesBtnGuop {
    width: calc(100% - 20px);
  }
  .question {
    font-size: 13px;
    .question-title {
      .editGrop {
        display: none !important;
      }
      .dropdownGrop {
        display: block !important;
      }
    }

    .rule {
      flex-direction: column;
      .rule-title {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
  /deep/ .el-dialog {
    width: 80%;
  }
}
</style>
<style lang="less">
.popoClass {
  width: 95px;
  min-width: 95px;
  .popoBox {
    display: flex;
    height: 28px;
    align-items: center;
    cursor: pointer;
    i,
    img {
      width: 18px;
      font-size: 16px;
      color: rgba(80, 88, 105, 0.5);
      margin-right: 8px;
    }
  }
}
</style>
